import { useId } from "react";
import "./Switch.css";

type Props = {
  label: string;
  description?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
};

export default function Switch({ label, description, checked, disabled, onChange }: Props) {
  const id = useId();
  return <label className="tnp-switch">
    <span className="tnp-switch-copy">
      <strong>{label}</strong>
      {description && <small id={`${id}-description`}>{description}</small>}
    </span>
    <input type="checkbox" role="switch" aria-label={label} aria-describedby={description ? `${id}-description` : undefined} checked={checked} disabled={disabled} onChange={event => onChange(event.target.checked)} />
    <span className="tnp-switch-track" aria-hidden="true" />
  </label>;
}
